import React from 'react'
import Image from '../../../images/sellerpolicies/4.png'
import { Link } from 'react-router-dom'

const Conflict_resolution = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Conflict Resolution</h2>
            <p>KAAY QC team conducts a thorough investigation upon the claim raised by the customer if the reason for the return is as listed per <Link to={'/sellerpolicies/return_and_replacement'}>the return & exchange policy</Link> seller will bear all the back shipping & transaction costs.</p>
            <p>In the case of returned products, KAAY protects the Seller by conducting a detailed discussion with the buyer, will collect video and picture proofs regarding the product quality, with the acknowledgment of the seller KAAY QC team to determine the validity of the Customer’s return claim. If the quality control identifies the customer’s return claim is upon the invalid ground, for whatever reason, the claim will be reverted back and the product will not be pickup up from the buyer.</p>
        </div>
      </div>
    </div>
  )
}

export default Conflict_resolution
